import Col, { ColProps } from './Col/index.tsx';
import Row, { RowProps } from './Row.tsx';

export { default as Col } from './Col/index.tsx';
export * from './Row.tsx';

const EnhancedRow: React.FC<RowProps> & {
  Col: React.FC<ColProps>;
} = Object.assign(Row, {
  Col
});

export default EnhancedRow;
